import {
  submissionExtendedLabel,
  SubmissionStatus,
  submissionStatusLabel,
} from "@smart/bridge-types-basic";
import {
  Badge,
  BadgeProps,
  Icon,
  Tooltip,
} from "@smart/itops-sb-design-system-dom";

import { GqlSubmission } from "../submissions";

const submissionStatusTheme: Record<SubmissionStatus, BadgeProps["theme"]> = {
  active: "information",
  completed: "success",
  cancelled: "highlight",
  draft: "highlight",
};

type SubmissionStatusPillProps = {
  syncStatus: GqlSubmission["values"]["syncStatus"];
  status: GqlSubmission["values"]["status"] | undefined;
  isInternalUse: boolean;
  isForm?: boolean;
};
export const SubmissionStatusPill = ({
  syncStatus,
  status,
  isInternalUse,
  isForm,
}: SubmissionStatusPillProps) => {
  let props: BadgeProps = {
    label: submissionStatusLabel[status || "draft"],
    theme: submissionStatusTheme[status || "draft"],
  };

  if (isForm) {
    props = {
      label: "Draft",
      iconRight: "regularSparkles",
      theme: "branding",
    };
  } else if (isInternalUse) {
    props = {
      label: submissionExtendedLabel.internalUse || "",
      theme: "highlight",
    };
  }

  return (
    <div className="flex gap-small">
      <Badge {...props} className="whitespace-nowrap" />
      {syncStatus === "pendingContactReview" && (
        <div className="flex rounded-small h-8 w-8 items-center justify-center bg-yellow-450">
          <Tooltip text="Contact data review required" offsetBy={15}>
            <Icon
              className="w-[1.2rem]"
              name="solidTriangleExclamation"
              dataTestId="pending-contact-review"
            />
          </Tooltip>
        </div>
      )}
    </div>
  );
};
